import * as R from 'remeda';
import { AnnotationListColumns } from '@rossum/api-client/shared';
import { GridFilterItem } from '@rossum/ui/x-data-grid-pro';
import { SCHEMA_COLUMN_PREFIX } from '../../document-list-base/schemaColumnPrefix';
import {
  getColumnField,
  metaColumnsMap,
} from '../../document-list-columns/utils';

const isUnknownSchemaColumn = (
  c: GridFilterItem,
  schemaColumnNames: Set<string>
) =>
  c.field.startsWith(SCHEMA_COLUMN_PREFIX) && !schemaColumnNames.has(c.field);

const isUnknownMetaColumn = (
  col: GridFilterItem,
  metaColumnNames: Set<string>
) =>
  !col.field.startsWith(SCHEMA_COLUMN_PREFIX) &&
  !metaColumnNames.has(col.field);

export const validateFilterItems = (
  columns: AnnotationListColumns,
  filterItems: GridFilterItem[]
) => {
  const schemaColumnNames = new Set(
    columns
      .filter(column => column.columnType === 'schema')
      .map(c =>
        getColumnField({
          columnType: c.columnType,
          field: c.schemaId,
          dataType: c.dataType,
        })
      )
  );
  const metaColumnNames = new Set(Object.keys(metaColumnsMap));

  const [invalidFilters, validFilters] = R.partition(
    filterItems,
    el =>
      isUnknownSchemaColumn(el, schemaColumnNames) ||
      isUnknownMetaColumn(el, metaColumnNames)
  );

  return {
    invalidFilters: invalidFilters.map(f => ({ ...f, isValid: false })),
    validFilters: validFilters.map(f => ({ ...f, isValid: true })),
  };
};
